import { GOOGLE_ID } from '../../Constants';
import React, {useEffect} from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Indentdashboard from './IndentDashboard/indentdashboard';
import IndentRequestMain from './IndentRequestMain';
import IndentTrackingMain from './IndentTrackingMain';
import ReactGA from "react-ga4";
import TrackDetails from './TrackAndTrace/TrackDetails';
const gaId = GOOGLE_ID;
ReactGA.initialize(gaId);

const IndentRoute = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
    return (
      <Switch>
            <Route path='/indents/:id' component={Indentdashboard} />
            <Route path='/indentrequest' component={IndentRequestMain} exact />
            <Route path='/indenttracking' component={IndentTrackingMain} exact />
            <Route path="/trackingdetails/:indent_id/:indent_id_sub"  element={TrackDetails} exact />
      </Switch>
        )
    }
export default IndentRoute
